export default __webpack_public_path__ + "static/media/about-us-home-care.00d42425.jpg";